import { render, staticRenderFns } from "./FeatureSettings.vue?vue&type=template&id=702cf502&scoped=true&"
import script from "./FeatureSettings.vue?vue&type=script&lang=ts&"
export * from "./FeatureSettings.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureSettings.vue?vue&type=style&index=0&id=702cf502&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702cf502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VContainer,VList,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle,VSwitch})
